module.exports = __webpack_public_path__ + "img/20210521114919724os1.cbca3476.png";